import { QueryHandlingService } from '@akebono/core';
import { Injectable, OnDestroy } from '@angular/core';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { AutoLotView, CurrentUserForSanctionsService } from '../const';
import {
  Lot,
  SanctionsServiceDataGQL,
  SanctionsServiceDataQuery,
} from '../modules/graphql/service/graphql-auto-main-service';

@Injectable({
  providedIn: 'root',
})
export class SanctionsService implements OnDestroy {
  private readonly currentUser$: Observable<SanctionsServiceDataQuery['currentUser']>;
  private readonly subscription: Subscription;

  constructor(
    private readonly qhs: QueryHandlingService,
    private readonly sanctionsServiceDataGQL: SanctionsServiceDataGQL,
  ) {
    this.currentUser$ = this.qhs.fetch(this.sanctionsServiceDataGQL, {}, 'cache-first').data.pipe(
      map((data) => data.currentUser),
      shareReplay(1),
    );

    this.subscription = this.currentUser$.subscribe();
  }

  isLotSanctioned$(lot: AutoLotView | Lot): Observable<boolean> {
    return combineLatest([of(lot), this.currentUser$]).pipe(
      map(([lot, currentUser]) => {
        return this.isLotSanctioned(lot, currentUser);
      }),
    );
  }

  isLotSanctioned(lot: AutoLotView | Lot, currentUser: CurrentUserForSanctionsService): boolean {
    if (!lot || currentUser.isAuctioneer || currentUser.isTranslator) {
      return false;
    }

    return !!lot.isRestricted;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
